// extracted by mini-css-extract-plugin
export var circle = "style-module--circle--be12b";
export var listButton = "style-module--listButton--16176";
export var notice = "style-module--notice--9d787";
export var play = "style-module--play--6cef5";
export var voice = "style-module--voice--1db73";